"use client";

import { PLATFORM_REGISTRY } from "@/lib/platforms/registry";
import { PlatformLogo } from "@/components/ui/platform-logo";
import type { PlatformId } from "@/types/platforms";
import { useJsonTranslation } from "@/hooks/useJsonTranslation";

const PLATFORM_ORDER: PlatformId[] = [
  "youtube",
  "linkedin",
  "x",
  "tiktok",
  "instagram",
  "facebook",
];

export function Platforms() {
  const { t } = useJsonTranslation("HomePlatforms");

  return (
    <div
      data-home-block="platform-ribbon"
      className="mx-auto max-w-6xl px-4 py-6 sm:px-6"
    >
      <div className="text-center">
        <p className="text-muted-foreground/60 mb-2 text-[11px] font-semibold tracking-[0.32em] uppercase sm:text-xs">
          {t("home.platforms.eyebrow")}
        </p>
        <h2 className="font-home-display text-foreground text-2xl font-semibold tracking-normal text-balance sm:text-3xl md:text-4xl">
          {t("home.platforms.title")}
        </h2>
        <p className="text-muted-foreground mx-auto mt-3 mb-6 max-w-2xl text-sm text-pretty sm:text-base">
          {t("home.platforms.subtitle")}
        </p>

        <div className="scrollbar-hide flex items-center gap-3 overflow-x-auto pb-1 sm:flex-wrap sm:justify-center sm:overflow-visible">
          {PLATFORM_ORDER.map((platformId) => {
            const config = PLATFORM_REGISTRY[platformId];
            return (
              <div
                key={platformId}
                className="glass glass-hover text-muted-foreground hover:text-foreground flex shrink-0 cursor-default items-center gap-2.5 rounded-full px-4 py-2.5 text-sm font-medium transition-all duration-300 hover:-translate-y-0.5"
              >
                <PlatformLogo platform={platformId} size={22} />
                {config.label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
